export const dnfKeys = ['d', 'D', '/'];
export const dnsKeys = ['s', 'S', '*'];
